import React from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
const relatedServices = [{
  title: "בית חולים כרמל - שירות סיעודי",
  description: "מרכז רפואי כרמל בחיפה מציע טיפול רפואי מתקדם. אנו מספקים מטפלים סיעודיים מנוסים להשגחה פרטית בבית החולים, המבטיחים פתרון מיידי וליווי צמוד למטופל בכל שלבי האשפוז וההחלמה, תוך דגש על יחס אישי ומקצועיות ללא פשרות.",
  link: "/NursingCareProviderInHaifaWithinHours"
}, {
  title: "המרכז הרפואי בני ציון",
  description: "בבית החולים בני ציון (רוטשילד) אנו מעמידים לרשותכם צוות סיעודי מיומן הזמין לקריאה דחופה. השירות כולל סיוע בניידות, האכלה, וליווי רגשי ופיזי, המאפשר למשפחה שקט נפשי בידיעה שיקירם נמצא בידיים הטובות ביותר עם פתרון מיידי.",
  link: "/NursingCareProviderInHaifaWithinHours"
}, {
  title: "בית חולים אלישע - טיפול פרטי",
  description: "בית החולים אלישע ידוע בסטנדרט השירות הגבוה שלו. המטפלים שלנו משתלבים במערך הטיפולי ומעניקים מעטפת תמיכה מלאה 24/7. אנו מתחייבים לספק פתרון מיידי לכל צורך סיעודי המתעורר במהלך השהות בבית החולים הפרטי המוביל בחיפה.",
  link: "/NursingCareProviderInHaifaWithinHours"
}, {
  title: "דף הבית – שירותי סיעוד",
  description: "זקוקים למטפל סיעודי עכשיו? אנו מספקים פתרונות סיעוד מתקדמים בפריסה ארצית עם דגש על מהירות, אמינות ומקצועיות ללא פשרות.",
  link: "/"
}, {
  title: "שירותי סיעוד בתל אביב – טיפול מיידי",
  description: "מענה סיעודי מהיר ומקצועי בתל אביב והסביבה. צוות המטפלים שלנו זמין להגעה תוך שעות ספורות לבית המטופל או לבית החולים.",
  link: "/NursingCaregiverInTelAvivWithinFiveHours"
}, {
  title: "שירותי סיעוד בירושלים – טיפול מיידי",
  description: "שירותי השגחה וסיעוד פרטי בירושלים. אנו מתחייבים למטפלים ישראלים מנוסים הזמינים לקריאה דחופה בכל רחבי הבירה.",
  link: "/NursingCareProviderInJerusalemWithinFiveHours"
}, {
  title: "שירותי סיעוד ברמת־גן – טיפול מיידי",
  description: "תושבי רמת גן נהנים משירות סיעודי מהיר ומקצועי. מטפלים מוסמכים להשגחה בבית החולים תל השומר או לטיפול ביתי צמוד.",
  link: "/NursingCareInRamatGanWithinHours"
}, {
  title: "שירותי סיעוד נוספים",
  description: "גלו את מגוון השירותים הרחב שלנו הכולל מטפלי לילה, השגחה פרטית לאחר ניתוח וליווי סיעודי ארוך טווח.",
  link: "/ServicesCitiesArticlesPage"
}, {
  title: "מאמרי בלוג על סיעוד",
  description: "מידע מקצועי, מדריכים וטיפים לבחירת מטפל סיעודי, זכויות מול ביטוח לאומי וכל מה שחשוב לדעת על עולם הסיעוד.",
  link: "/ProfessionalBlogPage"
}];
export default function RelatedServicesGrid() {
  return <section data-section-id="260705" id="מיקומים-וביתנות-בחיפה" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-primary mb-4">
            שירותי סיעוד בבתי החולים בחיפה
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            אנו מספקים מענה מהיר ומקצועי בכל המרכזים הרפואיים המובילים בחיפה, עם דגש על זמינות מיידית ואיכות טיפול גבוהה.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:gap-6">
          {relatedServices.map((service, i) => <Link key={i} to={service.link} className="block group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-lg" data-index={i}>
              <Card className="flex flex-col md:flex-row items-start md:items-center p-6 md:p-8 gap-4 md:gap-0 transition-all duration-300 group-hover:shadow-lg group-hover:border-primary/30 bg-card rounded-lg shadow-md">
                <div className="md:w-[35%] shrink-0">
                  <h3 className="font-default font-semibold text-xl text-foreground group-hover:text-primary transition-colors">
                    {service.title}
                  </h3>
                </div>
                
                <div className="hidden md:block w-px self-stretch bg-border mx-8 min-h-[3rem]"></div>
                
                <div className="flex-1">
                  <p className="text-muted-foreground text-base md:text-lg leading-relaxed font-default">
                    {service.description}
                  </p>
                </div>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}